module.exports = __webpack_public_path__ + "img/form-1@2x.6f49ac1.webp";